import moment from 'moment';

const BLOCKING_STATUS_NAMES = ['approved', 'draft', 'expired', 'hidden', 'declined'];

function parseDeadline(deadline) {
  if (deadline === null || deadline === undefined) return null;
  const raw = String(deadline).trim();
  if (!raw || raw === '∞') return null;

  const m = moment(raw, [
    moment.ISO_8601,
    'YYYY-MM-DD HH:mm:ss',
    'YYYY-MM-DD',
    'DD/MM/YYYY',
    'DD/MM/YY',
    'DD.MM.YYYY',
    'DD.MM.YY',
  ], true);

  return m.isValid() ? m : null;
}

export function isDeadlinePast(deadline) {
  const m = parseDeadline(deadline);
  if (!m) return false;
  return m.endOf('day').isBefore(moment());
}

export function canSellerMessageProject(project) {
  if (!project) return false;

  const status = Number(project.status);
  if (status === 2 || status === 3 || status === 4) return false;

  const statusName = String(project.status_name || project.statusName || '').toLowerCase();
  if (statusName && BLOCKING_STATUS_NAMES.some((s) => statusName.includes(s))) return false;

  if (isDeadlinePast(project.deadline_at)) return false;

  return true;
}

export function isSellerProjectMessage(message) {
  const role = message && message.user ? message.user.role : message?.role;
  return String(role || '').toLowerCase() === 'seller';
}

export function projectMessagesCount(project) {
  if (!project) return 0;

  if (Array.isArray(project.messages)) {
    return project.messages.filter((message) => isSellerProjectMessage(message)).length;
  }

  const num = Number(project.messages_count);
  return Number.isFinite(num) && num > 0 ? num : 0;
}
